import axios from 'axios';

const dbtCloudAPIKey = import.meta.env.VITE_DBT_CLOUD_API_KEY;

// eslint-disable-next-line turbo/no-undeclared-env-vars
if (import.meta.env.DEV) {
  axios.defaults.headers.common.Authorization = `Bearer ${dbtCloudAPIKey}`;
}

function getCSRF() {
  const tokenSplit = document.cookie.split('csrftoken=');
  // If csrftoken is not found, split returns array with one element (the whole string)
  if (tokenSplit.length === 1) {
    return '';
  }
  return tokenSplit[tokenSplit.length - 1].split(';')[0] || '';
}

// This must be an interceptor run for each request, because the CSRF token in the
// cookie will change if the user reauthenticates in another tab.
// @see https://github.com/axios/axios?tab=readme-ov-file#interceptors
axios.interceptors.request.use(
  (request) => {
    request.headers['X-CSRFToken'] = getCSRF();
    return request;
  },
  null,
  // prevents a promise from being created for executing this interceptor:
  { synchronous: true },
);
